import { useQuery } from "@tanstack/react-query";
import accountService from "../../services/accounts/account.service";

// 0015: the SINGLE fetch of UserInfo. React Query dedups by queryKey, so any number of consumers
// + the StrictMode double-mount collapse to exactly ONE network call. Keyed on the token so a new
// login refetches and no stale cross-user data is ever served. staleTime Infinity — UserInfo only
// changes on login/logout (logout removes this query in the logout action).
const useUserInfoQuery = ({ token, enabled }) =>
  useQuery({
    queryKey: ["userInfo", token],
    queryFn: () => accountService.getUserInfo(token).then((r) => r.data.payload),
    enabled,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });

export default useUserInfoQuery;
